'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Tr: ()=>Tr
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_Tr_variants_cjs_namespaceObject = require("./Tr.variants.cjs");
const external_Tr_context_cjs_namespaceObject = require("./Tr.context.cjs");
const index_cjs_namespaceObject = require("../Td/index.cjs");
const external_TrDrawer_index_cjs_namespaceObject = require("../TrDrawer/index.cjs");
const external_TrExpandable_index_cjs_namespaceObject = require("../TrExpandable/index.cjs");
const external_Table_index_cjs_namespaceObject = require("../Table/index.cjs");
const external_TBody_index_cjs_namespaceObject = require("../TBody/index.cjs");
const external_THead_index_cjs_namespaceObject = require("../THead/index.cjs");
const external_cleanTableProps_cjs_namespaceObject = require("../cleanTableProps.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const Chevron_index_cjs_namespaceObject = require("../../SVG/Chevron/index.cjs");
const Button_variants_cjs_namespaceObject = require("../../Button/Button.variants.cjs");
function Tr({ children, className, ...props }) {
    const { striped: tableStriped, bordered: tableBordered, headerSticky: tableHeaderSticky, placeholder, maxColumns, setMaxColumns } = (0, external_Table_index_cjs_namespaceObject.useTableContext)();
    const { striped: tableBodyStriped } = (0, external_TBody_index_cjs_namespaceObject.useTableBodyContext)();
    const { sticky: tableHeadSticky, isHeaderRow } = (0, external_THead_index_cjs_namespaceObject.useTableHeadContext)();
    const { isExpandable, isExpanded, setIsExpanded } = (0, external_TrExpandable_index_cjs_namespaceObject.useTableRowExpandableContext)();
    const { isDrawer, isOpen, setIsOpen } = (0, external_TrDrawer_index_cjs_namespaceObject.useTableRowDrawerContext)();
    const { striped: tableRowStriped, isGroupHeader } = props;
    const striped = !isGroupHeader && !isHeaderRow && (tableRowStriped ?? tableBodyStriped ?? tableStriped);
    const sticky = isHeaderRow && (tableHeadSticky ?? tableHeaderSticky);
    const classes = (0, external_utils_index_cjs_namespaceObject.cn)((0, external_Tr_variants_cjs_namespaceObject.trVariants)({
        ...props,
        striped,
        tableBordered,
        sticky,
        isHeaderRow
    }), className);
    const cleanedProps = (0, external_cleanTableProps_cjs_namespaceObject.cleanTableProps)(props);
    const onOpenClick = (0, external_react_namespaceObject.useCallback)(()=>{
        if (isExpandable) setIsExpanded(!isExpanded);
        if (isDrawer) setIsOpen(!isOpen);
    }, [
        isExpanded,
        isExpandable,
        isDrawer,
        isOpen,
        setIsExpanded,
        setIsOpen
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (isHeaderRow) {
            let newMaxColumns = (0, external_utils_index_cjs_namespaceObject.getHeaderColumnCount)(children);
            if (placeholder) newMaxColumns++;
            if (newMaxColumns > maxColumns) setMaxColumns(newMaxColumns);
        }
    }, [
        placeholder,
        maxColumns,
        isHeaderRow,
        children,
        setMaxColumns
    ]);
    const { buttonSlot } = (0, Button_variants_cjs_namespaceObject.buttonVariants)({});
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tr_context_cjs_namespaceObject.TableRowContext.Provider, {
        value: props,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("tr", {
            className: classes,
            ...cleanedProps,
            children: [
                (isExpandable || isDrawer) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Td, {
                    className: "w-11 py-0 hover:cursor-pointer",
                    contentClassName: "m-w-11",
                    onClick: onOpenClick,
                    "aria-label": isExpandable ? 'Row expand or collapse' : 'Drawer open or close',
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("button", {
                        className: (0, external_utils_index_cjs_namespaceObject.cn)(buttonSlot(), 'bg-transparent p-2'),
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Chevron_index_cjs_namespaceObject.Chevron, {
                            className: "text-primary-8 p-0",
                            isOpen: Boolean(isExpanded || isOpen)
                        })
                    })
                }),
                placeholder && !(isExpandable || isDrawer) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Td, {
                    placeholder: true
                }),
                children
            ]
        })
    });
}
exports.Tr = __webpack_exports__.Tr;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Tr"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
